export default __webpack_public_path__ + "static/media/recommends.77875e7d.png";